<template>
  <v-form ref="form">
    <v-row>
      <v-col class="pt-0 pb-0" cols="12">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBase.id') }}</v-col>
        </v-row>
        <v-text-field :value="data.baseID" @input="value=>updateForm('baseID', value)" :label="$t('formBase.id')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="12">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBase.name') }}</v-col>
        </v-row>
        <v-text-field :value="data.baseName" @input="value=>updateForm('baseName', value)" :label="$t('formBase.name')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="12">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBase.centerPositon') }}</v-col>
        </v-row>
        <v-text-field :value="data.centerPositon" @input="value=>updateForm('centerPositon', value)" :label="$t('formBase.centerPositon')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBase.circumference') }}</v-col>
        </v-row>
        <v-text-field :value="data.circumference" @input="value=>updateForm('circumference', value)" :label="$t('formBase.circumference')" solo="solo" flat="flat" outlined="outlined" required="required"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBase.sites') }}</v-col>
        </v-row>
        <v-text-field :value="data.sites" @input="value=>updateForm('sites', value)" type="number" :label="$t('formBase.sites')" solo="solo" flat="flat" outlined="outlined"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBase.bikeRacks') }}</v-col>
        </v-row>
        <v-text-field :value="data.bikeRacks" @input="value=>updateForm('bikeRacks', value)" type="number" :label="$t('formBase.bikeRacks')" solo="solo" flat="flat" outlined="outlined"></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="6">
        <v-row align="center">
          <v-col class="font-weight-medium" cols="auto">{{ $t('formBase.startDate') }}</v-col>
        </v-row>
        <v-text-field :value="data.startDate" @input="value=>updateForm('startDate', value)" :label="$t('formBase.startDate')" solo="solo" flat="flat" outlined="outlined"></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    updateForm (field, value) {
      this.$emit('update', { field, value })
    }
  }
}
</script>
